import { FullUserPrivileges } from '@utils/context/user';

const isAllowedToConsumePaidContent = (privileges?: FullUserPrivileges) =>
    Boolean(privileges?.isAllowedToConsumePaidContent);

export default isAllowedToConsumePaidContent;
